import sObjetos from '@/aplicacao/_servicos/objetos'

function State() {
    this.visivel = false
    this.imagem = ''
}

const mutations = {

    resetar(stateParam) {
        sObjetos.preencher(stateParam, new State())
    },

    setVisivel(state, payload) {
        state.visivel = payload
    },

    setImagem(state, payload) {
        state.imagem = payload
    },

}

const actions = {

    resetar({ commit }, payload) {
        commit('resetar', payload)
    },

    abrir({ commit }, payload) {
        commit('setImagem', payload)
        commit('setVisivel', true)
    },

    fechar({ commit }) {
        commit('setImagem', '')
        commit('setVisivel', false)
    },

}

const getters = {

}

export default {
    state: new State(),
    mutations,
    actions,
    getters,
}
